import LabelTableCell from 'Components/LabelTableCell'
import { useAuthorityContext } from 'Services/common/Features/Authority/Context/authorityContext'
import { info } from 'Util/colors'
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus'
import { Box, styled, TableCell, TableRow } from '@mui/material'
import { t } from 'ttag'

const StyledTableCell = styled(LabelTableCell)`
  width: 40%;
`

interface AuthorityTableRowProps {
  pta: string
}

function AuthorityTableRow({ pta }: Readonly<AuthorityTableRowProps>) {
  const { getCodespaceNameByCode } = useAuthorityContext()

  return (
    <TableRow sx={{ backgroundColor: info[50] }}>
      <StyledTableCell sx={{ color: info[900] }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1 }}>
          <DirectionsBusIcon sx={{ color: info[400] }} />
          {t`Authority`}
        </Box>
      </StyledTableCell>
      <TableCell sx={{ color: info[900] }}>{getCodespaceNameByCode(pta)}</TableCell>
    </TableRow>
  )
}

export default AuthorityTableRow
